import { render, staticRenderFns } from "./EditNoteDialog.vue?vue&type=template&id=5d6fdc57&scoped=true"
import script from "./EditNoteDialog.vue?vue&type=script&lang=js"
export * from "./EditNoteDialog.vue?vue&type=script&lang=js"
import style0 from "./EditNoteDialog.vue?vue&type=style&index=0&id=5d6fdc57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6fdc57",
  null
  
)

export default component.exports